<template>
  <div class="aboutUs-index">
    <div class="index-header-info">
      <div class="index-header-info_message">
        <div class="index-header-info_message-title">{{ $t('indexTitle') }}</div>
        <div class="index-header-info_message-text">
          {{ $t('indexTitleContent') }}
        </div>
      </div>
    </div>
    <div class="index-header-content">
      <div class="index-header-content_border">
        <div class="index-header-content_right">
          <div class="index-header-content_right-info-box">
            <span>{{ $t('nationCount') }}</span>
            {{ $t('countriesAndRegions') }}
          </div>
          <div class="index-header-content_right-info-box">
            <span>{{ $t('portCount') }}</span>
            {{ $t('cooperationPort') }}
          </div>
          <div class="index-header-content_right-info-box">
            <span>{{ $t('spaceCount') }}</span>
            {{ $t('cooperationYard') }}
          </div>
          <div class="index-header-content_right-info-box">
            <span>{{ $t('boxCount') }}</span>
            {{ $t('container') }}
          </div>
        </div>
      </div>
    </div>
    <div class="index-content">
      <div class="index-content-menu">
        <div class="index-content-menu-border">
          <div class="index-content-menu-title">
            <span>{{ $t('cargoIndexModuleOne') }}</span>
          </div>
          <div class="index-content-menu-text">{{ $t('cargoIndexModuleOneText') }}</div>
          <div><img class="index-content-menu-img" src="../../public/static/icon/server.svg"/></div>
        </div>
        <div class="index-content-menu-border">
          <div class="index-content-menu-title">
            <span>{{ $t('cargoIndexModuleTwo') }}</span>
          </div>
          <div class="index-content-menu-text">{{ $t('cargoIndexModuleTwoText') }}</div>
          <div><img class="index-content-menu-img" src="../../public/static/icon/cover.svg"/></div>
        </div>
        <div class="index-content-menu-border">
          <div class="index-content-menu-title">
            <span>{{ $t('cargoIndexModuleThree') }}</span>
          </div>
          <div class="index-content-menu-text">{{ $t('cargoIndexModuleThreeText') }}</div>
          <div><img class="index-content-menu-img" src="../../public/static/icon/global.svg"/></div>
        </div>
        <div class="index-content-menu-border">
          <div class="index-content-menu-title">
            <span>{{ $t('cargoIndexModuleFour') }}</span>
          </div>
          <div class="index-content-menu-text">{{ $t('cargoIndexModuleFourText') }}</div>
          <div><img class="index-content-menu-img" src="../../public/static/icon/ensure.svg"/></div>
        </div>
      </div>
    </div>
    <index-footer></index-footer>
  </div>
</template>

<script>
import IndexFooter from "../components/common/index-footer";
export default {
  name: "aboutUs",
  components: {IndexFooter},
}
</script>


<style lang="scss" scoped>
 .aboutUs-index{
   margin-top: 56px;
   position: absolute;
   top: 0;
   left: 0;
   right: 0;
   background: #f0f2f5;
   .index-header-info {
     height: 320px;
     background-image: url("../../public/static/index/cargoIndexBg.jpg");
     background-size: 100% 100%;
     width: 100%;
     display: flex;
     flex-direction: column;
     .index-header-info_message {
       width: 1000px;
       margin: 0 auto;
       text-align: center;

       .index-header-info_message-title {
         font-size: 40px;
         color: #FFFFFF;
         padding: 40px 0;
         line-height: 1;
         font-weight: 700;
       }

       .index-header-info_message-text {
         font-size: 14px;
         color: #FFFFFF;
         line-height: 20px;
         margin-bottom: 20px;
         font-weight: 700;
       }
     }
   }
   .index-header-content {
     background: #1F6CBA;
     padding: 18px 0;
     display: flex;
     justify-content: center;
     align-items: center;
     color: #FFFFFF;


     .index-header-content_border {
       width: 1200px;
       display: flex;
       justify-content: space-between;
       align-items: center;

       .index-header-content_left {
         display: flex;
         align-items: center;

         .index-header-content_left-title {
           font-size: 16px;
           font-weight: 700;
           color: #FFFFFF;
           line-height: 22px;
           letter-spacing: 1px;
         }

         .index-header-content_left-message {
           font-size: 12px;
           margin: 0 32px 0 32px;
           width: 228px;
         }

         .index-header-content_left-more {
           font-size: 12px;
           color: #FFFFFF;
           line-height: 17px;
           cursor: pointer;
         }
       }

       .index-header-content_right {
         display: flex;
         flex: 1;
         justify-content: space-around;
         margin-left: 48px;
         .index-header-content_right-info-box{
           font-size: 12px;
           color: #FFFFFF;
           line-height: 17px;
           white-space: nowrap;
           display: flex;
           flex-direction: column;
           align-items: center;
           font-weight: 400;
           span {
             font-size: 28px;
             font-weight: 400;
             color: #FFFFFF;
             line-height: 40px;
           }
         }

       }
     }
   }
   .index-content {
     width: 1200px;
     margin: 48px auto;
     .index-content-menu {
       display: flex;
       flex-wrap: wrap;
       justify-content: space-between;
       align-content: space-between;
       width: 100%;

       .index-content-menu-border {
         width: calc(50% - 24px);
         margin: 12px;
         background: #FFFFFF;
         box-shadow: 0px 4px 9px 0px rgba(0, 0, 0, 0.1000);
         border-radius: 6px;
         padding: 32px;
         display: flex;
         flex-direction: column;
         justify-content: space-between;

         .index-content-menu-title {
           font-size: 20px;
           font-weight: 600;
           color: #1F6CBA;
           line-height: 28px;

           img {
             width: 25px;
             height: 25px;
           }

           span {

           }
         }

         .index-content-menu-text {
           width: 420px;
           font-size: 16px;
           font-weight: 400;
           color: #999999;
           line-height: 20px;
           margin-top: 14px;
         }
         .index-content-menu-img{
           width: 66px;
           float: right;
         }
       }
     }
   }
 }
</style>